import React from 'react';
import { scoreTone, scoreLabel } from '../../lib/audits';

export default function AuditScoreChip({ score, showLabel = false, className = '' }) {
  const tone = scoreTone(score);
  return (
    <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-medium border ${tone} ${className}`}>
      <span>{score ?? '—'}</span>
      {showLabel && <span className="uppercase tracking-wider text-[9px] opacity-80">{scoreLabel(score)}</span>}
    </span>
  );
}
